import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertDriverMutationVariables = Types.Exact<{
  driverInput: Types.Drivers_Insert_Input;
}>;


export type InsertDriverMutation = { __typename?: 'mutation_root', insert_drivers_one?: { __typename?: 'drivers', id: number, status: string, tax_class: string, phone_type?: string | null, user_id?: number | null, created_at: string, updated_at: string, user?: { __typename?: 'users', id: number, display_name: string, email?: string | null, phone?: string | null, active: boolean, avatar_url?: string | null, default_role: string, created_at: string, updated_at: string, users_usertocustomers: Array<{ __typename?: 'usertocustomers', id: number, user_id: number, customer_id: number, created_at?: string | null, created_by: string, updated_at?: string | null, updated_by: string }> } | null } | null };


export const InsertDriverDocument = gql`
    mutation InsertDriver($driverInput: drivers_insert_input!) {
  insert_drivers_one(
    object: $driverInput
    on_conflict: {constraint: drivers_user_id_key, update_columns: [status, tax_class, updated_at]}
  ) {
    id
    status
    tax_class
    phone_type
    user_id
    created_at
    updated_at
    user {
      id
      display_name
      email
      phone
      active
      avatar_url
      default_role
      created_at
      updated_at
      users_usertocustomers {
        id
        user_id
        customer_id
        created_at
        created_by
        updated_at
        updated_by
      }
    }
  }
}
    `;
export type InsertDriverMutationFn = Apollo.MutationFunction<InsertDriverMutation, InsertDriverMutationVariables>;

/**
 * __useInsertDriverMutation__
 *
 * To run a mutation, you first call `useInsertDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDriverMutation, { data, loading, error }] = useInsertDriverMutation({
 *   variables: {
 *      driverInput: // value for 'driverInput'
 *   },
 * });
 */
export function useInsertDriverMutation(baseOptions?: Apollo.MutationHookOptions<InsertDriverMutation, InsertDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertDriverMutation, InsertDriverMutationVariables>(InsertDriverDocument, options);
      }
export type InsertDriverMutationHookResult = ReturnType<typeof useInsertDriverMutation>;
export type InsertDriverMutationResult = Apollo.MutationResult<InsertDriverMutation>;
export type InsertDriverMutationOptions = Apollo.BaseMutationOptions<InsertDriverMutation, InsertDriverMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/drivers/queries/insertDriver.mutation.gql}
 */
export async function insertDriver(
  variables: InsertDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertDriverMutation['insert_drivers_one']>
export async function insertDriver(
  variables: InsertDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertDriverMutation>
export async function insertDriver(
  variables: InsertDriverMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertDriverMutation['insert_drivers_one'] | InsertDriverMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertDriverMutation>(
    InsertDriverDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_drivers_one
}